<a class="notifications" href="javascript:;" (click)="toggleList()" [class.active]="listVisible">
  <mat-icon>notifications</mat-icon>

  <div class="indicator" [class.visible]="count > 0">
    {{ count }}
  </div>

</a>